export default __webpack_public_path__ + "static/WMSMDRINKINWATERMELONTEE_600x600-54c4e69c7f222f5fb93e4ef90cf571bc.png";